import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { Capacitor } from '@capacitor/core';
import { logger } from '@/lib/logger';

export const useNativeHaptics = () => {
  const isNative = Capacitor.isNativePlatform();

  const light = async () => {
    if (!isNative) return;
    try {
      await Haptics.impact({ style: ImpactStyle.Light });
    } catch (error) {
      // Haptics errors são silenciosos em produção
      if (import.meta.env.DEV) {
        logger.error('Haptics light error', error, { hook: 'useNativeHaptics', action: 'light' });
      }
    }
  };

  const medium = async () => {
    if (!isNative) return;
    try {
      await Haptics.impact({ style: ImpactStyle.Medium });
    } catch (error) {
      if (import.meta.env.DEV) {
        logger.error('Haptics medium error', error, { hook: 'useNativeHaptics', action: 'medium' });
      }
    }
  };

  const heavy = async () => {
    if (!isNative) return;
    try {
      await Haptics.impact({ style: ImpactStyle.Heavy });
    } catch (error) {
      if (import.meta.env.DEV) {
        logger.error('Haptics heavy error', error, { hook: 'useNativeHaptics', action: 'heavy' });
      }
    }
  };

  const success = async () => {
    if (!isNative) return;
    try {
      await Haptics.notification({ type: NotificationType.Success });
    } catch (error) {
      if (import.meta.env.DEV) {
        logger.error('Haptics success error', error, { hook: 'useNativeHaptics', action: 'success' });
      }
    }
  };

  const warning = async () => {
    if (!isNative) return;
    try {
      await Haptics.notification({ type: NotificationType.Warning });
    } catch (error) {
      if (import.meta.env.DEV) {
        logger.error('Haptics warning error', error, { hook: 'useNativeHaptics', action: 'warning' });
      }
    }
  };

  const error = async () => {
    if (!isNative) return;
    try {
      await Haptics.notification({ type: NotificationType.Error });
    } catch (error) {
      if (import.meta.env.DEV) {
        logger.error('Haptics error notification error', error, { hook: 'useNativeHaptics', action: 'error' });
      }
    }
  };

  const selection = async () => {
    if (!isNative) return;
    try {
      await Haptics.selectionStart();
      await Haptics.selectionChanged();
      await Haptics.selectionEnd();
    } catch (error) {
      if (import.meta.env.DEV) {
        logger.error('Haptics selection error', error, { hook: 'useNativeHaptics', action: 'selection' });
      }
    }
  };

  const vibrate = async (duration: number = 10) => {
    if (!isNative) return;
    try {
      await Haptics.vibrate({ duration });
    } catch (error) {
      if (import.meta.env.DEV) {
        logger.error('Haptics vibrate error', error, { hook: 'useNativeHaptics', action: 'vibrate', duration });
      }
    }
  };

  return {
    light,
    medium,
    heavy,
    success,
    warning,
    error,
    selection,
    vibrate,
    isNative
  };
};
